var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement, nothing } from "lit";
import { property } from "lit/decorators.js";
import { styles } from "./styles.js";
import { reset } from "../styles.js";
/**
 * Represents one item in a `w-breadcrumbs` trail.
 * Renders the slotted label as a link when `href` is set, or as text when it is not, and adds a separator after non-current items.
 *
 * [Warp component reference](https://warp-ds.github.io/docs/components/breadcrumbs/frameworks/elements)
 *
 * @parent w-breadcrumbs
 * @slot - The breadcrumb label content.
 */
class WarpBreadcrumbItem extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Marks this item as the current page.
         * Use this on the final breadcrumb item so it exposes `aria-current="page"` and does not render a trailing separator.
         */
        this.currentPage = false;
        /**
         * URL for linked breadcrumb items.
         * When omitted, the item renders as non-focusable text.
         */
        this.href = null;
    }
    static { this.styles = [reset, styles]; }
    /** @internal */
    get link() {
        return this.href
            ? html `<a
					part="link"
					class="s-text-link"
					href=${this.href}
					aria-current=${this.currentPage ? "page" : nothing}
					><slot></slot
				></a>`
            : html `<span
					part="text"
					class="s-text"
					aria-current=${this.currentPage ? "page" : nothing}
					><slot></slot
				></span>`;
    }
    /** @internal */
    get separator() {
        return !this.currentPage
            ? html `<span part="separator" class="separator" aria-hidden="true"
					>/</span
				>`
            : nothing;
    }
    render() {
        return html `${this.link}${this.separator}`;
    }
}
__decorate([
    property({ type: Boolean, attribute: "current-page" })
], WarpBreadcrumbItem.prototype, "currentPage", void 0);
__decorate([
    property({ type: String })
], WarpBreadcrumbItem.prototype, "href", void 0);
if (!customElements.get("w-breadcrumb-item")) {
    customElements.define("w-breadcrumb-item", WarpBreadcrumbItem);
}
export { WarpBreadcrumbItem };
//# sourceMappingURL=breadcrumb-item.js.map